
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreatePowermembershipDtoFormGroup() {
return new FormGroup({
    locationId: new FormControl<number | undefined>(undefined),
    supplierId: new FormControl<number | undefined>(undefined),
    networkAccess: new FormControl<number | undefined>(undefined),
    power: new FormControl<number | undefined>(undefined),
    outfeed: new FormControl<number | undefined>(undefined),
    kev: new FormControl<number | undefined>(undefined),
    totalExcl: new FormControl<number | undefined>(undefined),
    totalIncl: new FormControl<number | undefined>(undefined),
    returnHighRate: new FormControl<number | undefined>(undefined),
    returnLowRate: new FormControl<number | undefined>(undefined),
    validFrom: new FormControl<string | undefined>(undefined),
    validTo: new FormControl<string | undefined>(undefined),
})
;
}
      